import React, { useEffect, useState } from "react";
import "./Categories.css";
import Breadcrumb_comp from "../common-components/breadcrumb-comp/Breadcrumb_comp";

import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Filter_offcanvas from "../shop/all_Product/filter_offcanvas/Filter_offcanvas";
import {
  getAllCategories,
  getAllSubCategory,
  getAllBrands,
  getAllColors,
  getAllSizes,
} from "../../features/master/masterSlice";
import {
  getAllProducts,
  getGroupByProduct,
} from "../../features/products/productsSlice";

import {
  getCustomerLove,
  getHomeBanner,
  getHomeShopAndWatch,
} from "../../features/home/homeSlice";
import Product_Info_Card from "../common-components/product_info_card/Product_Info_Card";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Container, Row, Col, Tab, Nav } from "react-bootstrap";
import Category_Subcategory_Card from "../common-components/category_subcategory_card/Category_Subcategory_Card";
import { variant_type } from "../../utils/common";
import Pagination_Holder from "../common-components/pagination_holder/Pagination_Holder";
import Banner from "../home/banner/Banner";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFilter, faSort } from "@fortawesome/free-solid-svg-icons";
import Sort_Offcanvs from "../shop/all_Product/sort_offcanvas/Sort_offcanvas";
import Sort_offcanvas from "../shop/all_Product/sort_offcanvas/Sort_offcanvas";
const STEP = 4;

function Categories() {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  const [showFilter, setShowFilter] = useState(false);

  const handleShow = () => {
    setShowFilter(true);
    setShowSort(false);
  };

  const handleClose = () => {
    setShowFilter(false);
    setShowSort(false);
  };
  const [sortOrder, setSortOrder] = useState("");

  const [appliedSortOrder, setAppliedSortOrder] = useState("");

  const [filters, setFilters] = useState({
    category: [],
    subCategory: [],
    brands: [],
    colors: [],
    sizes: [],
  });

  const [appliedFilters, setAppliedFilters] = useState({
    category: [],
    subCategory: [],
    brands: [],
    colors: [],
    sizes: [],
  });

  const updateFilter = (key, value) => {
    setFilters((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  const [showSort, setShowSort] = useState(false);

  const [onPageChange, setOnPageChange] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [swiperInstance, setSwiperInstance] = useState(null);

  const categoryWiseProduct = useSelector(
    (state) => state.product.allProductsGroup,
  );

  const breadcrumbs = [
    { label: "Home", link: "/", isActive: false },
    { label: "Categories", link: "", isActive: true },
  ];

  const [visibleCounts, setVisibleCounts] = useState([]);

  // Scroll to a specific category section when "See Less" is clicked
  const handleToggle = (index, totalProducts, categoryId) => {
    setVisibleCounts((prevCounts) => {
      const newCounts = prevCounts.map((count, i) =>
        i === index
          ? count >= totalProducts
            ? STEP
            : Math.min(count + STEP, totalProducts)
          : count,
      );

      const handleShow = () => {
        setShowFilter(true);
        setShowSort(false);
      };

      const handleClose = () => {
        setShowFilter(false);
        setShowSort(false);
      };

      // Scroll if reducing to STEP
      if (prevCounts[index] >= totalProducts) {
        const el = document.getElementById(categoryId);
        if (el) {
          setTimeout(() => {
            el.scrollIntoView({ behavior: "smooth", block: "start" });
          }, 100); // delay to ensure layout update
        }
      }

      return newCounts;
    });
  };

  // const handleShow = () => {
  //   setShowFilter(true);
  //   setShowSort(false);
  // };

  const handleShowSort = () => {
    setShowSort(true);
    setShowFilter(false);
  };

  // const handleClose = () => {
  //   setShowFilter(false);
  //   setShowSort(false);
  // };

  const handleCloseSort = () => {
    setShowSort(false);
    setShowFilter(false);
  };

  // const location = useLocation();

  // const category_Id = location.state?.category_id;

  const params = new URLSearchParams(location.search);

  const category_Id = location.state?.category_id || params.get("category_id");

  const search = params.get("search");

  useEffect(() => {
    const scrollToId = location.state?.scrollToId;
    if (scrollToId) {
      const scroll = () => {
        const element = document.getElementById(scrollToId);
        if (element) {
          element.scrollIntoView({ behavior: "smooth", block: "start" });
        } else {
          setTimeout(scroll, 100);
        }
      };
      scroll();
    }
  }, [location.state]);

  const category = useSelector((state) => state.master.categories);
  const subcategories = useSelector((state) => state.master.subcategories);

  const brands = useSelector((state) => state.master.all_brands);
  const colors = useSelector((state) => state.master.all_colors);
  const sizes = useSelector((state) => state.master.all_sizes);

  const all_products = useSelector((state) => state.product.allProducts);

  const [selectedSubCategory, setSelectedSubCategory] = useState(null);
  const [childList, setChildList] = useState([]);
  const [childStatus, setChildStatus] = useState(""); // noChild

  const handleCategoryClick = (category_id) => {
    setStatus("");
    // dispatch(getAllSubCategory({ category_id }));
  };

  const [selectedCategoryId, setSelectedCategoryId] = useState("");

  // useEffect(() => {
  //   setSelectedCategoryId(category_Id || category[0]?.id);
  // }, [category, category_Id]);

  // useEffect(() => {
  //   if (category_Id) {
  //     setSelectedCategoryId(Number(category_Id));
  //   } else if (!selectedCategoryId && category?.length > 0) {
  //     setSelectedCategoryId(category[0]?.id);
  //   }
  // }, [category, category_Id]);

  useEffect(() => {
    if (category_Id) {
      setSelectedCategoryId(Number(category_Id));
      setOnPageChange(1);
    } else if (category?.length > 0) {
      setSelectedCategoryId(Number(category[0]?.id));
      setOnPageChange(1);
    }
  }, [category, category_Id]);

  // const params = new URLSearchParams(location.search);

  // const search = params.get("search");

  const productPerPage = 10;

  // useEffect(() => {
  //   dispatch(
  //     getAllProducts({
  //       name: search,

  //       // category_id:
  //       //   appliedFilters.category.length > 0
  //       //     ? appliedFilters.category.join(",")
  //       //     : selectedCategoryId || category_Id,

  //       category_id:
  //         appliedFilters.category.length > 0
  //           ? appliedFilters.category.join(",")
  //           : search
  //           ? ""
  //           : selectedCategoryId || category_Id,

  //       subcategory_id: appliedFilters.subCategory.join(","),
  //       brand_id: appliedFilters.brands.join(","),
  //       color_id: appliedFilters.colors.join(","),
  //       size_id: appliedFilters.sizes.join(","),

  //       sortBy: appliedSortOrder,
  //       page: onPageChange,
  //       per_page: productPerPage,
  //     }),
  //   );
  // }, [
  //   selectedCategoryId,
  //   onPageChange,
  //   category_Id,
  //   appliedSortOrder,
  //   appliedFilters,
  //   search,
  // ]);

  useEffect(() => {
    // Don't call API until the category is selected
    if (!selectedCategoryId && !search) return;

    dispatch(
      getAllProducts({
        name: search,

        category_id:
          appliedFilters.category.length > 0
            ? appliedFilters.category.join(",")
            : search
            ? ""
            : selectedCategoryId,

        subcategory_id: appliedFilters.subCategory.join(","),
        brand_id: appliedFilters.brands.join(","),
        color_id: appliedFilters.colors.join(","),
        size_id: appliedFilters.sizes.join(","),

        sortBy: appliedSortOrder,
        page: onPageChange,
        per_page: productPerPage,
      }),
    );
  }, [
    selectedCategoryId,
    onPageChange,
    appliedSortOrder,
    appliedFilters,
    search,
  ]);

  useEffect(() => {
    dispatch(getAllBrands());
    dispatch(getAllColors());
    dispatch(getAllSizes());
  }, []);

  const [status, setStatus] = useState("");

  const handlePageChange = (pageNumber) => {
    setOnPageChange(pageNumber);
  };

  const banner = useSelector((state) => state.home.banners);

  useEffect(() => {
    dispatch(getHomeBanner());
  }, [dispatch]);

  // useEffect(() => {
  //   if (all_products && all_products.data) {
  //     setTotalPages(all_products.total_pages);
  //     setOnPageChange(all_products.current_page);
  //   }
  // }, [all_products]);

  useEffect(() => {
    if (all_products && all_products.data) {
      setTotalPages(all_products.total_pages || 1);
    }
  }, [all_products]);

  // const handleApplyFilters = () => {
  //   setAppliedFilters(filters);

  //   // Highlight the selected category from filter
  //   if (filters.category.length > 0) {
  //     setSelectedCategoryId(Number(filters.category[0]));
  //   }

  //   dispatch(
  //     getAllProducts({
  //       category_id:
  //         filters.category.length > 0
  //           ? filters.category.join(",")
  //           : selectedCategoryId,

  //       subcategory_id:
  //         filters.subCategory.length > 0 ? filters.subCategory.join(",") : "",

  //       brand_id: filters.brands.join(","),
  //       color_id: filters.colors.join(","),
  //       size_id: filters.sizes.join(","),

  //       sortBy: sortOrder,
  //       page: 1,
  //     }),
  //   );

  //   setOnPageChange(1);
  //   setShowFilter(false);
  // };

  const handleApplyFilters = () => {
    setAppliedFilters(filters);

    if (filters.category.length > 0) {
      setSelectedCategoryId(Number(filters.category[0]));
    }

    setOnPageChange(1);
    setShowFilter(false);
  };

  // const handleClearFilters = () => {
  //   const emptyFilters = {
  //     category: [],
  //     subCategory: [],
  //     brands: [],
  //     colors: [],
  //     sizes: [],
  //   };

  //   setFilters(emptyFilters);
  //   setAppliedFilters(emptyFilters);

  //   setSortOrder("");

  //   dispatch(
  //     getAllProducts({
  //       category_id: selectedCategoryId,
  //       page: 1,
  //     }),
  //   );

  //   setShowFilter(false);
  // };

  const handleClearFilters = () => {
    const emptyFilters = {
      category: [],
      subCategory: [],
      brands: [],
      colors: [],
      sizes: [],
    };

    setFilters(emptyFilters);
    setAppliedFilters(emptyFilters);
    setSortOrder("");
    setAppliedSortOrder("");

    if (category?.length > 0) {
      const firstCategoryId = Number(category[0]?.id);

      setSelectedCategoryId(firstCategoryId);

      navigate(location.pathname, {
        replace: true,
        state: {},
      });
    }

    setOnPageChange(1);
    setShowFilter(false);
  };

  return (
    <section className="Categories_section_holder">
      <div className="container-fluid">
        <div className="Categories">
          <Breadcrumb_comp breadcrumbs={breadcrumbs} />

          <div className="heading_holder">
            <h4 className="heading_text">Essentials</h4>
          </div>

          <div className="cat_subcat_div">
            {status === "noCategory" ? (
              <p className="text-danger">No category available.</p>
            ) : (
              <div variant="pills" className="flex-row p-0 mb-3">
                <Swiper
                  className="mySwiper "
                  onSwiper={(swiper) => setSwiperInstance(swiper)}
                  pagination={{
                    dynamicBullets: true,
                    clickable: true,
                  }}
                  modules={[Pagination, Navigation]}
                  breakpoints={{
                    0: { slidesPerView: 2, spaceBetween: 10 },
                    350: { slidesPerView: 3, spaceBetween: 10 },
                    486: { slidesPerView: 3, spaceBetween: 10 },
                    576: { slidesPerView: 4, spaceBetween: 10 },
                    768: { slidesPerView: 5, spaceBetween: 10 },
                    992: { slidesPerView: 6, spaceBetween: 10 },
                    1200: { slidesPerView: 6, spaceBetween: 10 },
                  }}
                >
                  {category?.map((slide, index) => (
                    <SwiperSlide key={index} className="product-slide">
                      <Nav.Item>
                        <Nav.Link
                          eventKey={slide?.id}
                          // className={
                          //   category_Id
                          //     ? String(category_Id) === String(slide?.id)
                          //       ? "activecategory"
                          //       : ""
                          //     : selectedCategoryId === slide?.id
                          //     ? "activecategory"
                          //     : ""
                          // }
                          className={
                            Number(selectedCategoryId) === Number(slide?.id)
                              ? "activecategory"
                              : ""
                          }
                          // onClick={() => {
                          //   setSelectedCategoryId(slide?.id);

                          //   // Clear category_Id by resetting state
                          //   navigate(location.pathname, {
                          //     replace: true,
                          //     state: {},
                          //   });

                          //   handleCategoryClick(slide?.id);
                          // }}
                          onClick={() => {
                            setSelectedCategoryId(Number(slide?.id));
                            setOnPageChange(1);

                            navigate(
                              `${location.pathname}?category_id=${slide?.id}`,
                              {
                                replace: true,
                                state: {
                                  category_id: slide?.id,
                                },
                              },
                            );

                            handleCategoryClick(slide?.id);
                          }}
                        >
                          <Category_Subcategory_Card
                            className="product-image"
                            content={slide?.name}
                            image={process.env.REACT_APP_IMG_URL + slide?.image}
                            imgClassName="category-image"
                          />
                          <div className="triangle-right"></div>
                        </Nav.Link>
                      </Nav.Item>
                    </SwiperSlide>
                  ))}
                </Swiper>
              </div>
            )}
          </div>

          <div className="mobile_filter_btn">
            <button onClick={handleShow} className="filter_btn">
              <FontAwesomeIcon
                icon={faFilter}
                style={{ color: "rgb(136 74 41);" }}
              />{" "}
              <span>Filters</span>
            </button>

            <button onClick={handleShowSort} className="filter_btn ms-2">
              <FontAwesomeIcon
                icon={faSort}
                style={{ color: "rgb(136 74 41);" }}
              />{" "}
              <span>Sort</span>
            </button>
          </div>

          {all_products?.data?.length <= 0 ? (
            <p className="text-center text-danger mt-5">
              No products available for this selection.
            </p>
          ) : (
            <>
              <div className="heading_holder">
                <h4 className="heading_text">Products</h4>
              </div>

              <div className="row mb-5">
                {all_products?.data?.map((product, index) => {
                  let metal;
                  let size;
                  let triple;
                  if (
                    Number(product?.variant_type_id) ===
                    Number(variant_type.Single)
                  ) {
                    metal = product?.Product_Variants?.[0];
                  } else if (
                    Number(product?.variant_type_id) ===
                    Number(variant_type.Double)
                  ) {
                    metal = product?.Product_Variants?.[0];
                    size = metal?.Double_Variants?.[0];
                  } else if (
                    Number(product?.variant_type_id) ===
                    Number(variant_type.Triple)
                  ) {
                    metal = product?.Product_Variants?.[0];
                    size = metal?.Double_Variants?.[0];
                    triple = size?.Triple_Variants?.[0];
                  }

                  const activeVariant = triple || size || metal;

                  return (
                    <div
                      className="col-lg-4 col-md-4 col-sm-6 col-6 px-md-2 px-1 custom_5_col"
                      key={product?.id || index}
                    >
                      <Product_Info_Card
                        product={product}
                        id={product?.id}
                        imgSrc={process.env.REACT_APP_IMG_URL + product?.image}
                        vdoSrc={process.env.REACT_APP_IMG_URL + product?.video}
                        productName={product?.name}
                        priceText={activeVariant?.price || 0}
                        mrp={activeVariant?.mrp || 0}
                        kgText={activeVariant?.name}
                        savingPrice={
                          parseFloat(activeVariant?.mrp || 0) -
                          parseFloat(activeVariant?.price || 0)
                        }
                      />
                    </div>
                  );
                })}
              </div>
            </>
          )}
          <div className="pagination_div">
            <Pagination_Holder
              onPageChange={onPageChange}
              totalPages={totalPages}
              handlePageChange={handlePageChange}
            />
          </div>
        </div>
        <div className="buttons_div">
          <Filter_offcanvas
            show={showFilter}
            handleClose={handleClose}
            filters={filters}
            updateFilter={updateFilter}
            handleApplyFilters={handleApplyFilters}
            handleClearFilters={handleClearFilters}
            categories={category}
            subCategories={subcategories}
            colours={colors}
            sizes={sizes}
            brands={brands}
          />

          <Sort_offcanvas
            show={showSort}
            handleClose={handleCloseSort}
            sortOrder={sortOrder}
            setSortOrder={setSortOrder}
            appliedSortOrder={appliedSortOrder}
            setAppliedSortOrder={setAppliedSortOrder}
          />
        </div>
      </div>
    </section>
  );
}

export default Categories;
